import { apiClient, ApiError } from '@/shared/api';

import {
  EventDetailApiResponse,
  EventRegistrationBody,
  EventWaitListBody,
  EventsListApiResponse,
  EventTab,
} from '../config';

export interface GetEventsListParams {
  limit: number;
  offset: number;
  filter: EventTab;
}

export async function getEventsList(
  params: GetEventsListParams,
): Promise<EventsListApiResponse> {
  const searchParams = new URLSearchParams({
    limit: String(params.limit),
    offset: String(params.offset),
    filter: params.filter,
  });

  return apiClient<EventsListApiResponse>(`events?${searchParams.toString()}`);
}

export async function getEventOnceApi(slug: string) {
  try {
    const data = await apiClient<EventDetailApiResponse>(`events/${slug}`);
    return data.event;
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return null;
    }
    throw error;
  }
}

export async function registerEventApi(
  eventSlug: string,
  body: EventRegistrationBody,
): Promise<void> {
  await apiClient(`events/${eventSlug}/registration`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function joinEventWaitListApi(
  eventSlug: string,
  body: EventWaitListBody,
): Promise<void> {
  await apiClient(`events/${eventSlug}/wait-list`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
